import { render, staticRenderFns } from "./AdBudgetHandler.vue?vue&type=template&id=c8778c40&scoped=true&"
import script from "./AdBudgetHandler.vue?vue&type=script&lang=ts&"
export * from "./AdBudgetHandler.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8778c40",
  null
  
)

export default component.exports